<template>
  <div class="full-size">
    <div v-if="tabName === 'Tabelas de Domínios'">
      <TabelaDominios />
    </div>
    <div v-if="tabName === 'Hierarquia'">
      <Hierarquia />
    </div>
    <div v-if="tabName === 'Gerenciamento de Usuários'">
      <ControleUsuario />
    </div>
    <div v-if="tabName === 'E-mail Áreas'">
      <EmailAreas />
    </div>
    <div v-if="tabName === 'Municípios IBGE'">
      <MunicipiosIBGE />
    </div>
    <div v-if="tabName === 'Tags Unimed'">
      <TagsUnimed />
    </div>
    <div v-if="tabName === 'Parâmetros Gerais'">
      <ParametrosGerais />
    </div>
    <div v-if="tabName === 'Anexos'">
      <Anexos />
    </div>
    <div v-if="tabName === 'Manuais'">
      <Manuais />
    </div>
  </div>
</template>

<script>
import TabelaDominios from '../TabelaDominios/TabelaDominios'
import Hierarquia from '../Hierarquia/Hierarquia'
import ControleUsuario from '../ControleUsuario/ControleUsuario'
import EmailAreas from '../EmailAreas/EmailAreas'
import MunicipiosIBGE from '../MunicipiosIBGE/MunicipiosIBGE'
import TagsUnimed from '../TagsUnimed/TagsUnimed'
import ParametrosGerais from '../ParametrosGerais/ParametrosGerais'
import Anexos from '../Anexos/Anexos'
import Manuais from '../Manuais/Manuais'

export default {
  props: {
    tabIndex: {
      type: Number,
      default: 0
    },
    tabName: {
      type: String,
      default: 'E-mail Áreas'
    }
  },
  components: {
    TabelaDominios,
    Hierarquia,
    ControleUsuario,
    EmailAreas,
    MunicipiosIBGE,
    TagsUnimed,
    ParametrosGerais,
    Anexos,
    Manuais
  }
}
</script>

<style lang="sass" scoped>
.full-size
  width: 100% !important
  max-height: 1000px !important
</style>
